import Vue from 'vue';

/**
 * Module namespaced.
 */
export const namespaced = true;

/**
 * Module state.
 */
export const state = {
  list: [
    {
      id: Date.now() + 3,
      name: 'itau',
      agency: '3036',
      account: '315315-6',
    },
    {
      id: Date.now() + 2,
      name: 'itau',
      agency: '2546',
      account: '135125-3',
    },
    {
      id: Date.now() + 1,
      name: 'itau',
      agency: '1264',
      account: '648925-2',
    },
  ],
};

/**
 * Module mutations.
 */
export const mutations = {
  SAVE (state, account) {
    if (account.id) {
      const index = state.list.findIndex(({ id }) => account.id == id);

      Vue.set(state.list, index, account);

      return;
    }

    state.list.unshift({
      ...account,
      id: Date.now(),
    });
  },

  REMOVE (state, index) {
    Vue.delete(state.list, index);
  },
};
